<div class="ir-plugin th-plugin">
  <div class="ir-line ir-plugin-title" [ngClass]="{ 'ir-plugin-gray': showBreadcrumbs }">
    <div class="ir-line--right">
      <div
        class="ir-btn"
        *ngIf="showHelpButton"
        [ngClass]="showPluginHelp ? 'th-btn-action' : 'th-btn-normal'"
        (click)="showHidePluginHelp()"
      >
        <span>?</span>
      </div>
      <div
        class="ir-btn"
        [ngClass]="showValidations ? 'th-btn-action' : 'th-btn-normal'"
        [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
        [routerLink]="getEditRoute()"
      >
        <span>{{ (showValidations ? 'common.open' : 'common.edit') | translate }}</span>
      </div>
    </div>
    <div class="ir-line-content">
      <span>
        {{ showBreadcrumbs ? plugin.inspection.name + ' / ' : '' }}
        {{ showBreadcrumbs && plugin.point?.name ? plugin.point?.name + ' / ' : '' }}
        {{ 'plugins.associate-equipment.name' | translate }}</span
      >
    </div>
  </div>
  <div class="ir-line ir-plugin-validation" *ngIf="showValidations">
    <table class="ir-plugin-table">
      <tr class="th-plugin-line--content ir-plugin-gray">
        <td class="th-plugin-line--data" >
          <div *ngFor="let message of messages"><span  innerHtml="{{ message | translate: { value: plugin } }}"></span>
      </div>  </td>
      </tr>
    </table>
  </div>
  <div class="ir-plugin-content ir-plugin-info th-plugin-info" *ngIf="showContent">
    <p class="ir-plugin-instruction" *ngIf="showPluginHelp">
      <span innerHtml="{{ plugin?.description }}"></span>
    </p>
    <table class="ir-plugin-table optimisation-equipment" *ngIf="childrenInspections && childrenInspections.length">
      <tbody style="vertical-align: top">
        <tr class="th-plugin-line--subheader">
          <td width="30%">
            <span>{{ 'plugins.associate-equipment.equipment-id' | translate }}</span>
          </td>
          <td width="20%">
            <span>{{ 'plugins.associate-equipment.equipment-name' | translate }}</span>
          </td>
        </tr>
        <tr class="th-plugin-line--content" *ngFor="let m of childrenInspections">
          <td width="30%">
            <span>{{ m?.data?.machine?.Serial ? m?.data?.machine?.Serial : '&nbsp;' }}</span>
          </td>
          <td width="30%">
            <span>{{ m?.data?.machine?.name }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
